// Site
export const COCHES_HOSTNAME = 'coches.net'
export const MOTOS_HOSTNAME = 'motos.coches.net'
export const TEST_SUBDOMAINS = ['labs']

// Events
export const LEAD_EVENT = 'Lead Triggered'
export const PAGE_VIEWED = 'Page Viewed'
export const PHONE_VIEWED = 'Phone Viewed'

// Lead types
export const EMAIL_LEAD_TYPES = [
  'Professional Stock Ad Replied Email',
  'Detail Ad Replied Email',
  'Recommended Ad Replied Email',
  'Appointment Ad Replied Email',
  'Dealer Information Replied Email',
  'Professional Landing Email',
  'Start Pack Landing Email'
]
export const PHONE_LEAD_TYPES = [
  'Last Picture Phone Called',
  'Professional Stock Phone Called',
  'Detail Phone Called',
  'Recommended Phone Called',
  'Recent Search Phone Called',
  'Favorite Phone Called',
  'Alert Match Phone Called',
  'Saved Favorite Phone Called',
  'Professional Landing Phone Called',
  'Detail Dealer Phone Called',
  'Stock Dealer Header Phone Called',
  'Dealer Information Phone Called',
  'Image Gallery Phone Called',
  'Reservation Payment Confirmed Phone Called'
]

export const CONVERSION_LABEL = {
  OEM: 'ybxCCPStkoAYEOyIy_YD',
  SUBSCRIPTION_AD: '3bQXCLrKz4EYEOyIy_YD',
  PROFESSIONAL_SELLER: 'tQkLCPznnWcQ7IjL9gM',
  DEFAULT_SELLER: 'tVNPCLees2cQ7IjL9gM'
}

export const OEM_LEAD_TYPES = ['Lead to OEM']

// Seller types
export const PROFESSIONAL_SELLER_TYPE = 'profesional'

export const SUBSCRIPTION_LEAD_PROPERTIES = {
  MONTHLY_SUBSCRIPTION_FEE: 'monthly_subscription_fee'
}

export const SEGMENT_ANONYMOUS_COOKIE_KEY = 'ajs_anonymous_id'

export const DESTINATION_NAMES = {
  GOOGLE_TAG_MANAGER: 'Google Tag Manager',
  OPTIMIZELY: 'Optimizely'
}
